<template>
  <div>
    <v-row justify="center" v-if="programa && estudiante">
      <v-dialog v-model="dialog" scrollable :overlay="false" max-width="800px" transition="dialog-transition">
        <v-card class="kardex-dialog-card">
          <v-card-text class="pa-0">
            <div id="html-kardex">
              <div class="kd-topbar">
                <span class="kd-topbar-title">{{ programa.nombre_compuesto }}</span>
                <strong>Kardex de pagos</strong>
              </div>

              <div class="kd-doc-title">Estado de cuenta</div>  

              <div class="kd-banner">
                <img :src="getimgkardex(programa.universidad)" class="kd-banner-img" />
              </div>

              <div class="kd-student-section">
                <div class="kd-info-field">
                  <div class="kd-field-label">{{ posgraduante_str }}</div>
                  <div class="kd-field-value">
                    {{ estudiante.nombres }} {{ estudiante.pri_apellido }} {{ estudiante.seg_apellido }}
                  </div>
                </div>
                <div class="kd-info-field">
                  <div class="kd-field-label">Documento de identidad</div>
                  <div class="kd-field-value">{{ estudiante.num_doc }}</div>
                </div>
                <div class="kd-info-field">
                  <div class="kd-field-label">Fecha de elaboración</div>
                  <div class="kd-field-value">{{ date }}</div>
                </div>
              </div>

              <div class="kd-summary-section">
                <div class="kd-section-label">Resumen financiero</div>
                <div class="kd-cards-grid">
                  <div class="kd-stat-card kd-sc-total">
                    <div class="kd-sc-label">Total del plan</div>
                    <div class="kd-sc-val">{{ fmtNum(total_plan) }}</div>
                    <div class="kd-sc-note">{{ plan_pagos.length }} cuotas registradas</div>
                  </div>
                  <div class="kd-stat-card kd-sc-adjust">
                    <div class="kd-sc-label">Ajuste total</div>
                    <div class="kd-sc-val">{{ fmtNum(total_ajuste) }}</div>
                    <div class="kd-sc-note">{{ cuotas_con_ajuste }} cuotas con ajuste</div>
                  </div>
                  <div class="kd-stat-card kd-sc-paid">
                    <div class="kd-sc-label">Monto pagado</div>
                    <div class="kd-sc-val">{{ fmtNum(ya_pagado) }}</div>
                    <div class="kd-sc-note">{{ cuotas_canceladas }} cuotas pagadas</div>
                  </div>
                  <div class="kd-stat-card kd-sc-pending">
                    <div class="kd-sc-label">Saldo vencido</div>
                    <div class="kd-sc-val">{{ saldo_pendiente }}</div>
                    <div class="kd-sc-note">Pendiente a la fecha</div>
                  </div>
                  <div class="kd-stat-card kd-sc-pct">
                    <div class="kd-sc-label">Avance</div>
                    <div class="kd-sc-val">{{ porcentaje_avance.toFixed(1) }}%</div>
                    <div class="kd-sc-note">Del plan cubierto</div>
                  </div>
                </div>
              </div>

              <div class="kd-progress-section">
                <div class="kd-progress-track">
                  <div class="kd-progress-fill" :style="{ width: porcentaje_avance + '%' }"></div>
                </div>
                <div class="kd-progress-meta">
                  <strong>{{ fmtNum(ya_pagado) }} pagados</strong>
                  <span>{{ fmtNum(total_saldo) }} restantes · total {{ fmtNum(total_plan) }}</span>
                </div>
              </div>

              <div class="kd-table-section">
                <v-progress-linear indeterminate v-if="loading_plan" />
                <div class="kd-section-label"> ETAPA FORMATIVA </div> 
                <div> Incluye exclusivamente matrícula y colegiaturas. No incorpora costos de investigación ni titulación. </div>
                
                <table class="kd-table upper--text">
                  <thead>
                    <tr>
                      <th>Concepto</th>
                      <th>N° de cuota</th>
                      <th>Fecha vencimiento</th>
                      <th>Asignación mensual</th>
                      <th>Ajustes</th>
                      <th>Pagado</th>
                      <th>Saldo</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in detalleCuotasPrincipales" :key="item.id" :class="getRowClass(item)">
                      <td class="kd-concept-cell">{{ item.concepto_pago }}</td>
                      <td><span class="kd-num-circle">{{ item.nro_cuota }}</span></td>
                      <td class="kd-date-cell">{{ item.fecha_pago }}</td>
                      <td class="kd-amount-cell">{{ item.monto }}</td>
                      <td> {{ item.descuento }} </td>
                      <td> {{ item.monto_pagado }} </td>
                      <td :class="['kd-amount-cell', getSaldoClass(item)]">{{ item.saldo }}</td>
                      <td><span :class="['kd-badge', getRowStatus(item).badge]">{{ getRowStatus(item).text }}</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              

              <div class="kd-table-section kd-extra-fee-section kd-print-new-page" v-if="detalleTrabajoMonografia.length">
                <div class="kd-section-label"> ETAPA DE INVESTIGACIÓN </div> 
                <div> Derecho exigible luego de aprobar satisfactoriamente la Etapa Formativa </div>
                
                <table class="kd-table kd-table-compact kd-extra-fee-table upper--text">
                  <thead>
                    <tr>
                      <th>Concepto</th>
                      <th>N° de cuota</th>
                      <th>Asignación mensual</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in detalleTrabajoMonografia" :key="item.id">
                      <td class="kd-concept-cell">{{ item.concepto_pago }}</td>
                      <td><span class="kd-num-circle">{{ item.nro_cuota }}</span></td>
                      <td class="kd-amount-cell">{{ item.monto }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="kd-table-note">* Se habilita una vez presentado el trabajo final</div>
              </div>

              <div class="kd-table-section kd-extra-fee-section" v-if="detalleMonografiaFinal.length">
                <div class="kd-section-label"> ETAPA DE TITULACIÓN </div> 
                <div> Derecho aplicable únicamente cuando el participante opte por titularse mediante el convenio institucional. </div>

                <table class="kd-table kd-table-compact kd-extra-fee-table upper--text">
                  <thead>
                    <tr>
                      <th>Concepto</th>
                      <th>N° de cuota</th>
                      <th>Asignación mensual</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in detalleMonografiaFinal" :key="item.id">
                      <td class="kd-concept-cell">{{ item.concepto_pago }}</td>
                      <td><span class="kd-num-circle">{{ item.nro_cuota }}</span></td>
                      <td class="kd-amount-cell">{{ item.monto }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="kd-table-note">* Se habilita una vez habilitado el trabajo final</div>
              </div>

              <div class="kd-totals-section">
                <div class="kd-section-label">{{ xplan_programa.nombre }}</div>
                <table class="kd-table kd-table-compact upper--text">
                  <thead>
                    <tr>
                      <th>Concepto</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="item-tr" v-for="item in xplan_programa.cobros_programa" :key="item.id">
                      <td class="kd-concept-cell">{{ item.concepto_pago.nombre }}</td>
                      <td class="kd-amount-cell">{{ fixed(item.monto) }} </td>
                    </tr>
                    <!-- <tr class="kd-total-highlight">
                      <td class="kd-concept-cell">Saldo pendiente vencido</td>
                      <td class="kd-amount-cell kd-saldo-venc"> {{ saldo_pendiente }} </td>
                    </tr> -->
                  </tbody>
                </table>
              </div>

              <div class="kd-totals-section" v-if="descuentos && descuentos.length">
                <div class="kd-section-label">Descuentos aplicados</div>
                <table class="kd-table kd-table-compact upper--text">
                  <thead>
                    <tr>
                      <th>Detalle</th>
                      <th>Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="item-tr" v-for="item in descuentos" :key="item.id">
                      <td>
                        <p class="p-descuento-title" > {{ item.concepto_pago?.nombre }}  </p>
                        <p class="p-descuento-subtitle" > {{ item.motivo.descripcion }} </p>
                      </td>
                      <td class="kd-amount-cell kd-tr-green">{{ fixed(item.monto) }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="kd-totals-section" v-if="xpromo && xpromo.id">
                <div class="kd-section-label" style="margin-bottom: 0;">PromociÓn aplicada</div>
                <b>- {{ xpromo.nombre }}</b>
                <table class="kd-table kd-table-compact upper--text">
                  <thead>
                    <tr>
                      <th> </th>
                      <th>Valor descuento</th>
                      <th>Monto de descuento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr>
                      <td colspan="3" style="text-align: left;"> <b>{{ xpromo.nombre }}</b> </td> 
                    </tr> -->
                    <tr class="item-tr" v-for="d in xpromo.detalle_promocion" :key="d.id">
                      <td>
                        <p class="p-descuento-title" > {{ d.nombre_concepto }}  </p>
                        <!-- <p class="p-descuento-subtitle" > {{ item.motivo.descripcion }} </p> -->
                      </td>
                      <td class="kd-amount-cell kd-tr-green">{{ d.valor_descuento }} {{ d.is_porcentaje?'%':'Bs.' }} </td>
                      <td class="kd-amount-cell kd-tr-green">{{ fixed(d.x_valor_descuento) }} </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- <div class="kd-status-section">
                <div :class="['kd-callout', tiene_mora ? 'kd-callout-warn' : 'kd-callout-ok']">
                  <div class="kd-cl-title">Estado al {{ date }}</div>
                  <div class="kd-cl-body" v-if="!tiene_mora">
                    No tiene cuotas vencidas registradas en el kardex.
                  </div>
                  <div class="kd-cl-body" v-else>
                    Presenta saldo vencido por <strong>{{ saldo_pendiente }}</strong>.
                  </div>
                </div>
              </div> -->

              <div class="kd-footer">
                <div>
                  <div class="kd-fc-name" v-if="asesor">
                  {{ asesor.sexo == 'M' ? 'Licenciado' : 'Licenciada' }} : {{ asesor.nombres }} {{ asesor.pri_apellido }}
                  {{ asesor.seg_apellido }}
                  </div>
                  <div class="kd-fc-detail" v-if="sede">
                    Departamento Administrativo - Contable · {{ sede.nombre }}<br>
                    Cel.: {{ sede.telefono1 ? sede.telefono1 : '.................' }}{{ sede.telefono2 ? ` · ${sede.telefono2}` : '' }}<br>
                    Dirección: {{ sede.direccion ? ` ${sede.direccion}` : '..............' }}
                    <template v-if="sede.ciudad && sede.ciudad.nombre"> · {{ sede.ciudad.nombre }} - Bolivia</template>
                  </div>
                </div>
                <div class="kd-footer-right">
                  <div class="kd-fr-label">Documento generado</div>
                  <div class="kd-fr-date">{{ date }}</div>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="$store.state.isonlyread" color="red lighten-2" rounded @click="printRecibo">
              <v-icon class="mr-1"> mdi-printer</v-icon> Imprimir o pdf <v-icon class="ml-1"> mdi-file-pdf</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
              Cerrar <v-icon> mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <KardexPagosUpi ref="refKardexPagosUpi" />
    <KardexPagosUpiBol ref="refKardexPagosUpiBol" />
  </div>
</template>

<script>
  import { Printd } from 'printd';
  import moment from 'moment';
  import { mapState } from 'vuex';
  import xaxios from '@/xaxios';
import gql from 'graphql-tag';
// import { concepto_ids_orden } from '@/views/upi/planes/utils'
import KardexPagosUpi from './KardexPagosUpi.vue';
import KardexPagosUpiBol from './KardexPagosUpiBolivia.vue';
import {id_mod_monografia,id_mod_defen_tesis} from '@/views/programa_reg_from_oferta/crear-programa-esam.js'


  moment.locale('es');
  const CONCEPTOS_DETALLE_CUOTAS = [1, 2];
  // const CONCEPTOS_TRABAJO_MONOGRAFIA = [382, 383];
  const CONCEPTOS_TRABAJO_MONOGRAFIA = [385,id_mod_monografia, id_mod_defen_tesis];
  const CONCEPTOS_MONOGRAFIA_FINAL = [3];
  const KARDEX_STYLES = `
    *, *::before, *::after { box-sizing: border-box; }
    body { font-family: Roboto, Arial, sans-serif; font-size: 13px; color: #1d2630; }
    #html-kardex { background: #fff; color: #1d2630; }
    .kd-topbar { background: #12324a; color: #fff; padding: 10px 22px; display: flex; justify-content: space-between; align-items: flex-start; gap: 18px; font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; font-weight: 600; }
    .kd-topbar-title { flex: 1 1 auto; min-width: 0; opacity: 0.9; white-space: normal; overflow-wrap: anywhere; line-height: 1.35; }
    .kd-topbar strong { flex: 0 0 auto; line-height: 1.35; text-align: right; }
    .kd-doc-title { text-align: center; padding: 12px 20px 8px; font-size: 18px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #12324a; border-bottom: 3px solid #c9962c; }
    .kd-banner { border-bottom: 1px solid #d9e1e8; background: #f8fafc; }
    .kd-banner-img { display: block; width: 100%; max-height: 178px; object-fit: contain; }
    .kd-student-section { padding: 16px 22px; background: #f3f6f8; border-bottom: 1px solid #d9e1e8; display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
    .kd-field-label, .kd-section-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.08em; color: #6d7b88; margin-bottom: 4px; font-weight: 700; }
    .kd-section-label { margin-bottom: 12px; letter-spacing: 0.1em; }
    .kd-field-value { font-size: 13px; font-weight: 600; color: #1d2630; line-height: 1.35; }
    .kd-summary-section, .kd-table-section, .kd-totals-section, .kd-status-section { padding: 16px 22px; border-bottom: 1px solid #d9e1e8; }
    .kd-cards-grid { display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; }
    .kd-stat-card { border: 1px solid #d9e1e8; border-radius: 4px; padding: 12px 14px; background: #fff; }
    .kd-sc-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.07em; color: #6d7b88; margin-bottom: 6px; font-weight: 700; }
    .kd-sc-val { font-size: 18px; font-weight: 700; line-height: 1.2; margin-bottom: 4px; font-variant-numeric: tabular-nums; }
    .kd-sc-note { font-size: 11px; color: #6d7b88; }
    .kd-sc-total { border-top: 3px solid #12324a; } .kd-sc-total .kd-sc-val { color: #12324a; }
    .kd-sc-adjust { border-top: 3px solid #5b6b8a; } .kd-sc-adjust .kd-sc-val { color: #5b6b8a; }
    .kd-sc-paid { border-top: 3px solid #18704d; } .kd-sc-paid .kd-sc-val { color: #18704d; }
    .kd-sc-pending { border-top: 3px solid #a53b3b; } .kd-sc-pending .kd-sc-val { color: #a53b3b; }
    .kd-sc-pct { border-top: 3px solid #c9962c; } .kd-sc-pct .kd-sc-val { color: #8b6418; }
    .kd-progress-section { padding: 0 22px 16px; border-bottom: 1px solid #d9e1e8; }
    .kd-progress-track { height: 8px; background: #e5ebf0; border-radius: 20px; overflow: hidden; margin: 8px 0 6px; }
    .kd-progress-fill { height: 100%; background: #18704d; border-radius: 20px; }
    .kd-progress-meta { display: flex; justify-content: space-between; gap: 12px; font-size: 11px; color: #6d7b88; }
    .kd-progress-meta strong { color: #18704d; }
    .kd-table { width: 100%; border-collapse: collapse; font-size: 12px; }
    .kd-table thead tr { background: #eef3f7; border-bottom: 1px solid #cbd6df; }
    .kd-table th { padding: 8px 10px; text-align: right; font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; color: #526372; }
    .kd-table th:first-child, .kd-table td:first-child { text-align: left; }
    .kd-table tbody tr { border-bottom: 1px solid #e5ebf0; }
    .kd-table tbody tr:last-child { border-bottom: none; }
    .kd-table td { padding: 9px 10px; text-align: right; color: #1d2630; vertical-align: middle; }
    .kd-table-compact td { padding: 8px 10px; }
    .kd-extra-fee-section { padding: 10px 22px 11px; background: #fbfcfd; border-left: 4px solid #c9962c; }
    .kd-extra-fee-section .kd-section-label { margin-bottom: 6px; color: #8b6418; }
    .kd-extra-fee-table { font-size: 11px; }
    .kd-extra-fee-table th { padding: 5px 8px; }
    .kd-extra-fee-table td { padding: 5px 8px; }
    .kd-extra-fee-table .kd-num-circle { width: 18px; height: 18px; font-size: 10px; }
    .kd-table-note { margin-top: 8px; font-size: 11px; color: #526372; font-style: italic; }
    .kd-extra-fee-section .kd-table-note { margin-top: 5px; font-size: 10px; }
    .kd-row-paid { background: rgba(24, 112, 77, 0.05); }
    .kd-row-overdue { background: rgba(165, 59, 59, 0.05); }
    .kd-row-future { background: rgba(201, 150, 44, 0.08); }
    .kd-concept-cell { font-weight: 600; }
    .kd-num-circle { display: inline-flex; width: 22px; height: 22px; align-items: center; justify-content: center; background: #dce8f2; color: #12324a; border-radius: 50%; font-size: 11px; font-weight: 700; }
    .kd-badge { display: inline-block; padding: 3px 8px; border-radius: 2px; font-size: 10px; font-weight: 700; letter-spacing: 0.04em; text-transform: uppercase; white-space: nowrap; }
    .kd-b-ok { background: #dcefe7; color: #18704d; }
    .kd-b-venc { background: #f2dddd; color: #a53b3b; }
    .kd-b-fut { background: #f8edcf; color: #8b6418; }
    .kd-date-cell { color: #526372; font-size: 12px; }
    .kd-amount-cell { font-variant-numeric: tabular-nums; font-weight: 600; }
    .kd-saldo-ok, .kd-tr-green { color: #18704d; }
    .kd-saldo-venc { color: #a53b3b; font-weight: 700; }
    .kd-saldo-pend, .kd-tr-amber { color: #8b6418; }
    .kd-total-highlight { background: #f8fafc; }
    .kd-callout { flex: 1; border-radius: 4px; padding: 12px 16px; border: 1px solid; }
    .kd-callout-ok { background: #dcefe7; border-color: rgba(24, 112, 77, 0.25); color: #18704d; }
    .kd-callout-warn { background: #f2dddd; border-color: rgba(165, 59, 59, 0.25); color: #a53b3b; }
    .kd-cl-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 4px; }
    .kd-cl-body { font-size: 12px; line-height: 1.5; }
    .kd-footer { padding: 16px 22px; display: grid; grid-template-columns: 1fr auto; gap: 20px; align-items: end; background: #f3f6f8; }
    .kd-fc-name { font-size: 13px; font-weight: 700; color: #1d2630; margin-bottom: 4px; }
    .kd-fc-detail { font-size: 11px; color: #526372; line-height: 1.7; }
    .kd-footer-right { text-align: right; }
    .kd-fr-label { font-size: 10px; color: #6d7b88; text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 4px; font-weight: 700; }
    .kd-fr-date { font-size: 13px; font-weight: 700; color: #1d2630; }
    .upper--text { text-transform: uppercase; }
    .p-descuento-title { padding: 0; margin: 0 0 3px; line-height: 1.2; font-weight: 700; }
    .p-descuento-subtitle { text-transform: none; color: #6d7b88; padding: 0; margin: 0; line-height: 1.25; font-size: 0.85em; }
    @media print {
      body { background: white; }
      .kd-print-new-page { break-before: page; page-break-before: always; }
      .kd-progress-fill, .kd-stat-card, .kd-callout, .kd-badge, .kd-num-circle, .kd-row-paid, .kd-row-overdue, .kd-row-future { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  `;
  export default {
    components:{KardexPagosUpi, KardexPagosUpiBol},
    data() {
      return {
        cssText: null,
        firma_path: process.env.VUE_APP_URL_BG_FIRMA_USER,
        api_rest: process.env.VUE_APP_API_REST,
        dialog: false,
        estudiante: null,
        programa: null,
        asesor: null,
        cobros_programa: [],
        plan_pagos: [],
        date: null,
        totales: [], 
        posgraduante_str:'POSGRADUANTE',
        xplan_programa: {}, 
        descuentos: [],
        loading_plan: false,
        xpromo:{},
        loading_promo: false,
      };
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      },
    },
    computed: {
      ...mapState({
        sede: (state) => state.modsede.items.find((t) => t.id == state.CARGO.sede.id),
        // programa: (state) => state.programa.value,
      }),
      getcobros_programa(){
        return this.cobros_programa.filter(x=>x.monto)
      },
      saldo_pendiente() {
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        return this.plan_pagos
          .filter(item => {
            if (!item.fecha_pago) return false;
            return new Date(item.fecha_pago) < hoy;
          })
          .reduce((acc, item) => acc + (Number(item.saldo) || 0), 0)
          .toFixed(2);
      },
      total_plan() {
        return this.plan_pagos.reduce((acc, item) => acc + (Number(item.monto) || 0), 0);
      },
      total_ajuste() {
        return this.plan_pagos.reduce((acc, item) => acc + (Number(item.descuento) || 0), 0);
      },
      cuotas_con_ajuste() {
        return this.plan_pagos.filter((item) => Number(item.descuento) > 0).length;
      },
      total_saldo() {
        return this.plan_pagos.reduce((acc, item) => acc + (Number(item.saldo) || 0), 0);
      },
      ya_pagado() {
        return this.plan_pagos
          .filter((item) => this.getRowStatus(item).xpagado)
          // .reduce((acc, item) => acc + (Number(item.monto) || 0) - (Number(item.descuento) || 0), 0);
          .reduce((acc, item) => acc + (Number(item.monto_pagado) || 0), 0);
      },
      cuotas_canceladas() {
        return this.plan_pagos.filter((item) => this.getRowStatus(item).xpagado).length;
      },
      porcentaje_avance() {
        if (!this.total_plan) return 0;
        return Math.min(100, Math.max(0, (this.ya_pagado / this.total_plan) * 100));
      },
      tiene_mora() {
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        return this.plan_pagos.some((item) => {
          if (!item.fecha_pago) return false;
          return new Date(item.fecha_pago) < hoy && Number(item.saldo) > 0;
        });
      },
      detalleCuotasPrincipales() {
        return this.plan_pagos.filter((item) => this.conceptoEnLista(item, CONCEPTOS_DETALLE_CUOTAS));
      },
      detalleTrabajoMonografia() {
        return this.plan_pagos.filter((item) => this.conceptoEnLista(item, CONCEPTOS_TRABAJO_MONOGRAFIA));
      },
      detalleMonografiaFinal() {
        return this.plan_pagos.filter((item) => this.conceptoEnLista(item, CONCEPTOS_MONOGRAFIA_FINAL));
      },
    },
    methods: {
      getConceptoPagoId(item) {
        return Number(item.concepto_pago_id || (item.concepto_pago && item.concepto_pago.id));
      },
      conceptoEnLista(item, conceptos) {
        return conceptos.includes(this.getConceptoPagoId(item));
      },
      showThisView(estudiante, plan_programa, plan_pagos, programa, idinscripcion,descuentos) {
        this.loading_plan = false;
        const u = this.$store.state.CARGO.sede.unidad_negocio;
        if(u == 1 && programa.universidad && programa.universidad.id == 301){
          this.$nextTick(() => {
            this.$refs.refKardexPagosUpiBol.showThisView(estudiante, plan_programa, plan_pagos, programa, idinscripcion);
          });
          return;
        } 
        

        // window.console.log('KARDEX::', JSON.stringify(plan_pagos, null, 4));
        // window.console.log('KARDEX::>', programa);
        // window.console.log('KARDEX::>', plan_programa);
        if(programa.universidad && programa.universidad.id == 301){
          this.$nextTick(() => {
            this.$refs.refKardexPagosUpi.showThisView(estudiante, plan_programa, plan_pagos, programa, idinscripcion);
          });
          return;
        }
        // window.console.log('KARDEX::', JSON.stringify(plan_pagos, null, 4));
        // window.console.log('plan_programa::', plan_programa,plan_programa);
        this.dialog = true;
        this.xplan_programa = plan_programa;
        this.descuentos = descuentos;
        //window.console.log('COBRSO::', JSON.stringify(plan_pagos, null, 4));
        if (!plan_programa.cobros_programa) plan_programa.cobros_programa = [];
        this.programa = programa;
        this.cobros_programa = plan_programa.cobros_programa.map((cobro) => ({ ...cobro, monto: 0 }));
        this.getkardex(idinscripcion);
        this.getSede();
        // this.getPromoAplicada(idinscripcion); 
        const vue = this;
        
        this.date = moment().format('DD MMMM [del] YYYY');
        this.estudiante = estudiante;
        plan_pagos.forEach((x) => {
          const conceptoPagoId = x.concepto_pago_id || (x.concepto_pago && x.concepto_pago.id);
          const monto = Number(x.monto ?? x.total) || 0;
          const concepto = vue.cobros_programa.find((c) => c.concepto_pago.id == conceptoPagoId);
          if (concepto) concepto.monto += monto;
        });
        const name = this.programa.nombre_compuesto.toLowerCase();
        if(
          name.includes('licenciatura') || 
          name.includes('curso en') || 
          name.includes('técnico')
        ){
          this.posgraduante_str = 'ESTUDIANTE'
        }else{
          this.posgraduante_str = 'POSGRADUANTE'
        }
        /*this.plan_pagos = plan_pagos.map((plan) => ({
        ...plan,
        monto: plan.monto.toFixed(2),
        descuento: plan.descuento.toFixed(2),
        saldo: plan.saldo.toFixed(2),
      }));*/
      },
      fixed(m) {
        if (!m) return '';
        if(typeof(m) == 'string') {
          try {
            return Number(m).toFixed(2);
          } catch (error) {
            return m
          }
        }
        return m.toFixed(2);
      },
      fmtNum(n) {
        const num = Number(n) || 0;
        return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      isOverdue(item) {
        if (!item.fecha_pago) return false;
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        return new Date(item.fecha_pago) < hoy;
      },
      getRowClass(item) {
        const saldo = Number(item.saldo) || 0;
        if (saldo === 0) return 'kd-row-paid';
        return this.isOverdue(item) ? 'kd-row-overdue' : 'kd-row-future';
      },
      getSaldoClass(item) {
        const saldo = Number(item.saldo) || 0;
        if (saldo === 0) return 'kd-saldo-ok';
        return this.isOverdue(item) ? 'kd-saldo-venc' : 'kd-saldo-pend';
      },
      
      getRowStatus(item) {
        const saldo = Number(item.saldo) || 0;
        if (saldo === 0 && item.plazo_pago === 'CANCELADO') return { badge: 'kd-b-ok', text: 'Pagado', xpagado: true };
        if (saldo === 0 && item.plazo_pago === 'REGULARIZACIÓN') return { badge: 'kd-b-ok', text: 'Pagado regul.', xpagado: true };
        if (saldo === 0 && item.plazo_pago == 'LIQUIDACIÓN') return { badge: 'kd-b-venc', text: 'Liquidado', xpagado: false };
        if (item.plazo_pago === 'PAGO PARCIALDESCUENTO') return { badge: 'kd-b-ok', text: 'Pagado descuento', xpagado: true };
        if (item.plazo_pago === 'PAGO PARCIAL/REGULARIZACIÓN') return { badge: 'kd-b-ok', text: 'Pagado regul.', xpagado: true };
        if (item.plazo_pago === 'PAGO PARCIAL/LIQUIDACIÓN') return { badge: 'kd-b-ok', text: 'Pagado parcial', xpagado: true };
        if (item.plazo_pago === 'PAGO PARCIAL') return { badge: 'kd-b-ok', text: 'Pagado parcial', xpagado: true };
        if (this.isOverdue(item)) return { badge: 'kd-b-venc', text: 'Vencido', xpagado: false };
        return { badge: 'kd-b-fut', text: 'Pendiente', xpagado: false };
      },
      async getkardex(idinscripcion) {
        this.loading_plan = true;
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
        const url2 = `${this.api_rest}/api/v1/inscripcion/${idinscripcion}/plan-pago`
        const data1 = await xaxios.get(url).then(({ data }) => data).catch(e=>e);
        const data2 = await xaxios.get(url2).then(({ data }) => data).catch(e=>e);

        window.console.log('KARDEX:', data1.data);
        window.console.log('data2:', data2.data);

        const concepto_ids_orden_1 = [1,2,id_mod_monografia,id_mod_defen_tesis,385, 3]
        
        const prioridad = new Map(
          concepto_ids_orden_1.map((id, index) => [id, index])
        ); 
        data1.data.sort((a, b) => {
          const prioridadA = prioridad.get(a.concepto_pago_id) ?? Infinity;
          const prioridadB = prioridad.get(b.concepto_pago_id) ?? Infinity;

          // Primero ordena por concepto_pago_id (según tu mapa de prioridad)
          if (prioridadA !== prioridadB) {
            return prioridadA - prioridadB;
          }

          // Si tienen la misma prioridad, ordena por nro_cuota
          return a.nro_cuota - b.nro_cuota;
        });

        data1.data.forEach(x=>{
          const item_plan = data2.data.find(p=>p.plan_pago_id == x.id)
          x.xitem_plan = item_plan;
        })

        this.cobros_programa.sort((a, b) => {
          const prioridadA = prioridad.get(a.concepto_pago.id) ?? Infinity;
          const prioridadB = prioridad.get(b.concepto_pago.id) ?? Infinity;
          return prioridadA - prioridadB;
        })
        
        vue.plan_pagos = data1.data.map((plan) => ({
          ...plan,
          monto: (Number(plan.total) || 0).toFixed(2),
          descuento: (Number(plan.descuento) || 0).toFixed(2),
          saldo: (Number(plan.saldo) || 0).toFixed(2),
          monto_pagado: (Number(plan.xitem_plan?.monto_pagado) || 0),
        }));
        
        this.loading_plan = false;
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      printRecibo() {
        const d = new Printd();
        d.print(document.getElementById('html-kardex'), [this.cssText]);
      },
      getSede() {
        let id = this.$store.state.CARGO.sede.id;
        const sql = gql`query{getSede(id: ${id}) { id nombre nombre_recibo modelo_recibo direccion telefono1 ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          // this.sede = data.getSede;
          this.sede.modelo_recibo = process.env.VUE_APP_URL_BG_RECIBO_SEDE + data.getSede.modelo_recibo;
        });
      },
      closeDialog() {
        this.dialog = false;
        this.$nextTick(() => {
          this.cobros_programa = [];
          this.plan_pagos = [];
          this.estudiante = null;
          this.programa = null;
          // this.asesor = null;
          this.date = null;
        });
      },
      getimgkardex(u) {
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // window.console.log('kardexxxxxx', unidad, u);
        if (unidad == 1) {
          if (!u) return 'img/bg_kardex.png';
          else if (u.id == 128) return 'img/bg_kardexubj.png';
          else if (u.id == 2) return 'img/bg_kardexuajms.png';
          else return 'img/bg_kardex.png';
        } else if (unidad == 2) {
          if (!u) return 'img/bg_kardex_cca.webp';
          else if (u.id == 128) return 'img/bg_kardexubj_cca.webp';
          else if (u.id == 2) return 'img/bg_kardexuajms_cca.webp';
          else if (u.id == 9) return 'img/bg_kardexxx_cca.webp';
          else return 'img/bg_kardex_cca.webp';
        } else if (unidad == 3) {
          return 'img/bg_kardex_ck.webp';
        } else if (unidad == 10) {
          if (!u) return 'img/bg_kardex_dbs.webp';
          else if (u.id == 2) return 'img/bg_kardex_dbsuajms.webp';
          else if (u.id == 9) return 'img/bg_kardex_dbsxx.webp';
          return 'img/bg_kardex_dbs.webp';
        }else if (unidad == 14) {          
          return this.sede.modelo_recibo;
        }else if (unidad == 15) {          
          return this.sede.modelo_recibo;
        }
        return 'img/bg_kardex.png';
      },

      async getPromoAplicada(idins){
        this.loading_promo = true;
        this.xpromo = {}
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/${idins}/inscripcion`;
        const res = await xaxios .get(url, {}) .then(({data})=>data).catch(e=>e);
        this.loading_promo = false;
        if(res && res.data){
          window.console.log('ressprmoo', res.data,this.xplan_programa);
          const aplicado = res.data.detalle_promocion.map(dp=>{
            let r = 0
            const cobro = this.xplan_programa.cobros_programa.find(
              c => c.concepto_pago.id == dp.concepto_pago_id
            )

            if (cobro) {
              if (dp.is_porcentaje) {
                r = cobro.monto - ( (cobro.monto * Number(dp.valor_descuento)) / 100 )
              } else {
                r = cobro.monto - Number(dp.valor_descuento)
              }
            }

            return {
              ...dp,
              x_valor_descuento: r
            }
          });

          res.data.detalle_promocion = aplicado;
          this.xpromo = res.data;
        }
        
      }
    },
    mounted() {
      this.asesor = this.$store.state.DATA_USER;
      this.cssText = KARDEX_STYLES;
    },
  };
</script>

<style>
.kardex-dialog-card {
  overflow: hidden;
}

#html-kardex {
  background: #fff;
  color: #1d2630;
}

.kd-topbar {
  background: #12324a;
  color: #fff;
  padding: 10px 22px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 600;
}

.kd-topbar-title {
  flex: 1 1 auto;
  min-width: 0;
  opacity: 0.9;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.kd-topbar strong {
  flex: 0 0 auto;
  line-height: 1.35;
  text-align: right;
}

.kd-doc-title {
  text-align: center;
  padding: 12px 20px 8px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #12324a;
  border-bottom: 3px solid #c9962c;
}

.kd-banner {
  border-bottom: 1px solid #d9e1e8;
  background: #f8fafc;
}

.kd-banner-img {
  display: block;
  width: 100%;
  max-height: 178px;
  object-fit: contain;
}

.kd-student-section {
  padding: 16px 22px;
  background: #f3f6f8;
  border-bottom: 1px solid #d9e1e8;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.kd-field-label,
.kd-section-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6d7b88;
  margin-bottom: 4px;
  font-weight: 700;
}

.kd-section-label {
  margin-bottom: 12px;
  letter-spacing: 0.1em;
}

.kd-field-value {
  font-size: 13px;
  font-weight: 600;
  color: #1d2630;
  line-height: 1.35;
}

.kd-summary-section,
.kd-table-section,
.kd-totals-section,
.kd-status-section {
  padding: 16px 22px;
  border-bottom: 1px solid #d9e1e8;
}

.kd-cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.kd-stat-card {
  border: 1px solid #d9e1e8;
  border-radius: 4px;
  padding: 12px 14px;
  background: #fff;
}

.kd-sc-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #6d7b88;
  margin-bottom: 6px;
  font-weight: 700;
}

.kd-sc-val {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
  font-variant-numeric: tabular-nums;
}

.kd-sc-note {
  font-size: 11px;
  color: #6d7b88;
}

.kd-sc-total {
  border-top: 3px solid #12324a;
}

.kd-sc-total .kd-sc-val {
  color: #12324a;
}

.kd-sc-adjust {
  border-top: 3px solid #5b6b8a;
}

.kd-sc-adjust .kd-sc-val {
  color: #5b6b8a;
}

.kd-sc-paid {
  border-top: 3px solid #18704d;
}

.kd-sc-paid .kd-sc-val {
  color: #18704d;
}

.kd-sc-pending {
  border-top: 3px solid #a53b3b;
}

.kd-sc-pending .kd-sc-val {
  color: #a53b3b;
}

.kd-sc-pct {
  border-top: 3px solid #c9962c;
}

.kd-sc-pct .kd-sc-val {
  color: #8b6418;
}

.kd-progress-section {
  padding: 0 22px 16px;
  border-bottom: 1px solid #d9e1e8;
}

.kd-progress-track {
  height: 8px;
  background: #e5ebf0;
  border-radius: 20px;
  overflow: hidden;
  margin: 8px 0 6px;
}

.kd-progress-fill {
  height: 100%;
  background: #18704d;
  border-radius: 20px;
  transition: width 0.5s ease;
}

.kd-progress-meta {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 11px;
  color: #6d7b88;
}

.kd-progress-meta strong {
  color: #18704d;
}

.kd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.kd-table thead tr {
  background: #eef3f7;
  border-bottom: 1px solid #cbd6df;
}

.kd-table th {
  padding: 8px 10px;
  text-align: right;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #526372;
}

.kd-table th:first-child,
.kd-table td:first-child {
  text-align: left;
}

.kd-table tbody tr {
  border-bottom: 1px solid #e5ebf0;
}

.kd-table tbody tr:last-child {
  border-bottom: none;
}

.kd-table td {
  padding: 9px 10px;
  text-align: right;
  color: #1d2630;
  vertical-align: middle;
}

.kd-table-compact td {
  padding: 8px 10px;
}

.kd-extra-fee-section {
  padding: 10px 22px 11px;
  background: #fbfcfd;
  border-left: 4px solid #c9962c;
}

.kd-extra-fee-section .kd-section-label {
  margin-bottom: 6px;
  color: #8b6418;
}

.kd-extra-fee-table {
  font-size: 11px;
}

.kd-extra-fee-table th {
  padding: 5px 8px;
}

.kd-extra-fee-table td {
  padding: 5px 8px;
}

.kd-extra-fee-table .kd-num-circle {
  width: 18px;
  height: 18px;
  font-size: 10px;
}

.kd-table-note {
  margin-top: 8px;
  font-size: 11px;
  color: #526372;
  font-style: italic;
}

.kd-extra-fee-section .kd-table-note {
  margin-top: 5px;
  font-size: 10px;
}

.kd-row-paid {
  background: rgba(24, 112, 77, 0.05);
}

.kd-row-overdue {
  background: rgba(165, 59, 59, 0.05);
}

.kd-row-future {
  background: rgba(201, 150, 44, 0.08);
}

.kd-concept-cell {
  font-weight: 600;
}

.kd-num-circle {
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  background: #dce8f2;
  color: #12324a;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
}

.kd-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.kd-b-ok {
  background: #dcefe7;
  color: #18704d;
}

.kd-b-venc {
  background: #f2dddd;
  color: #a53b3b;
}

.kd-b-fut {
  background: #f8edcf;
  color: #8b6418;
}

.kd-date-cell {
  color: #526372;
  font-size: 12px;
}

.kd-amount-cell {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.kd-saldo-ok,
.kd-tr-green {
  color: #18704d;
}

.kd-saldo-venc {
  color: #a53b3b;
  font-weight: 700;
}

.kd-saldo-pend,
.kd-tr-amber {
  color: #8b6418;
}

.kd-total-highlight {
  background: #f8fafc;
}

.kd-callout {
  flex: 1;
  border-radius: 4px;
  padding: 12px 16px;
  border: 1px solid;
}

.kd-callout-ok {
  background: #dcefe7;
  border-color: rgba(24, 112, 77, 0.25);
  color: #18704d;
}

.kd-callout-warn {
  background: #f2dddd;
  border-color: rgba(165, 59, 59, 0.25);
  color: #a53b3b;
}

.kd-cl-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
}

.kd-cl-body {
  font-size: 12px;
  line-height: 1.5;
}

.kd-footer {
  padding: 16px 22px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: end;
  background: #f3f6f8;
}

.kd-fc-name {
  font-size: 13px;
  font-weight: 700;
  color: #1d2630;
  margin-bottom: 4px;
}

.kd-fc-detail {
  font-size: 11px;
  color: #526372;
  line-height: 1.7;
}

.kd-footer-right {
  text-align: right;
}

.kd-fr-label {
  font-size: 10px;
  color: #6d7b88;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin-bottom: 4px;
  font-weight: 700;
}

.kd-fr-date {
  font-size: 13px;
  font-weight: 700;
  color: #1d2630;
}

.upper--text {
  text-transform: uppercase;
}

.p-descuento-title {
  padding: 0;
  margin: 0 0 3px;
  line-height: 1.2;
  font-weight: 700;
}

.p-descuento-subtitle {
  text-transform: none;
  color: #6d7b88;
  padding: 0;
  margin: 0;
  line-height: 1.25;
  font-size: 0.85em;
}

@media print {
  .kd-print-new-page {
    break-before: page;
    page-break-before: always;
  }
}
</style>
